import { type IAsyncSelectWidget } from '../../IAsyncSelectWidget.ts';

/**
 * Gestisce la restituzione dei campi da utilizzare come label.
 * Il campo valueField è deprecato, ma se presente viene
 * restituito per retrocompatibilità
 */
export function getLabelFields(widget: IAsyncSelectWidget) {
  if (widget.labelFields?.length) return widget.labelFields;
  // Retrocompatibilità
  if (widget.labelField) return [widget.labelField];
  return [];
}
